import React, {useContext, useEffect, useRef} from "react";
import {CBContext} from "./CBContext";
import {FormModal, getPatchValues} from "../utils/utils";
import {Box, Button, CircularProgress} from "@mui/material";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import API from "../utils/API";
import {ProgressContext} from "../utils/ProgressContext";
import {Form, Formik} from "formik";
import {udinStatusSchema} from "./validations";
import TextField from "../utils/components/TextField";
import {generalAPI, removeNulls} from "./utils";


async function udinStatusAPI(transactionID, data){
    const response = await API.post(`cbs/${transactionID}/udin-status/`, data);
    return response.data;
}

export default function UdinStatusForm(){
    const {cbState, cbDispatch} = useContext(CBContext);
    const {modalType, transactionId, status} = cbState.baseData;
    const {handleProgressOpen, handleProgressClose} = useContext(ProgressContext);
    const formikRef = useRef();
    const queryClient = useQueryClient();

    const {data: cbData, isFetching: cbIsFetching} = useQuery(
        ['cbs', cbState.baseData.transactionId],
        () => generalAPI(`cbs/${cbState.baseData.transactionId}/`),
        {
            refetchOnWindowFocus: false,
            retry: false,
            enabled: cbState.baseData.status >= 4,
            select: data => {
                data = removeNulls(data);
                return data;
            }
        }
    );

    useEffect(() => {
        if (!cbState.baseData.pages[cbState.baseData.activeStep].visited && cbData && cbState.baseData.status !== 0 && !cbState.baseData.cloning) {
            cbDispatch({
                type: 'addUpdateFormData',
                data: {'udinStatus': cbData}
            })
        }
    }, [cbData, cbState.baseData.status, cbState.baseData.activeStep, cbState.baseData.pages, cbState.baseData.cloning, cbDispatch]);


    const mutation = useMutation(
        ['cbs', transactionId, 'udin-status'],
        data => udinStatusAPI(transactionId, data),
        {
            onMutate: () => handleProgressOpen(),
            onSettled: () => handleProgressClose(),
            onSuccess: () => {
                cbDispatch({
                    type: 'addBaseData',
                    data: {modalType: ''}
                });
                queryClient.invalidateQueries(['cbs', cbState.baseData.transactionId])
            }
        }
    )

    const footer = <>
        <Button variant={'outlined'} onClick={() => cbDispatch({
            type: 'addBaseData',
            data: {modalType: ''}
        })}>Close</Button>
        <Button sx={{ml: 3}} disabled={status < 4} onClick={() => formikRef.current.submitForm()} variant={'contained'}>Save</Button>
    </>

    return (
        <>
            <FormModal
                open={modalType === 'udinStatus'}
                title={'UDIN Status'}
                maxWidth={'xl'}
                width={'500px'}
                footer={footer}
            >
                <Formik
                    innerRef={formikRef}
                    initialValues={cbState.formData.udinStatus}
                    validationSchema={udinStatusSchema}
                    enableReinitialize={true}
                    validateOnChange={false}
                    onSubmit={values => mutation.mutate(getPatchValues(cbState.updateData.udinStatus, values))}
                >
                    <Form>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '16px',
                                left: '150px'
                            }}
                        >
                            {cbIsFetching && <CircularProgress size={'2rem'}/>}
                        </Box>
                        <TextField
                            name={'udin_status'}
                            label={'UDIN Status'}
                            required
                            fullWidth
                            disabled={status < 4}
                            select
                            options={{
                                "-1": "SELECT",
                                "0": 'ADDED',
                                "1": 'LINKED',
                                "2": 'REVOKED'
                            }}
                        />
                    </Form>
                </Formik>
            </FormModal>
        </>
    )
}